export { deepMergeWithArrayPrimitiveOverrides } from '@splunk/visualization-encoding/utils/deepMergeWithArrayPrimitiveOverrides';
